import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { computed } from 'vue';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataTableToolbarActions',
  props: {
    class: {},
    name: {}
  },
  setup(__props: any) {

    const page = usePage<SharedData>();

    const props = __props;

    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    key: `toolbar-actions-${props.name}-${selectedCompanyId.value}`,
    class: _normalizeClass(_unref(cn)('flex flex-wrap gap-4 lg:flex-nowrap sm:items-center', props.class))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})